module.exports = __webpack_public_path__ + "static/media/teammember1.2073ad8f.jfif";